'use strict';

/* Services */
import dbAdminService from '../../../services/db-admin/db-admin.service';

/* Views */
import dbAdminList from './db/list/db-admin-list.component';
import dbAdminEdit from './db/edit/db-admin-edit.component';

/* Module */
export default angular.module('conduu.ap.superadmin', [dbAdminList, dbAdminEdit, dbAdminService])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/superadmin/index.js